import { DataGrid, GridColDef } from "@mui/x-data-grid";
import * as React from "react";

interface ITableDataGridProps {
  columns: Array<GridColDef>;
  totalRecords?: number;
  rows: Array<object>;
  page?: number;
  rowsPerPage?: number;
  rowId?: string;
  hidePagination?: boolean;
  columnVisibilityModel?: any;
}

const TableDataGrid: React.FC<ITableDataGridProps> = ({
  rows,
  rowId,
  columns,
  hidePagination,
  totalRecords,
  columnVisibilityModel = {},
}) => {
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      columnVisibilityModel={columnVisibilityModel}
      rowCount={totalRecords || 0}
      columnHeaderHeight={50}
      rowHeight={54}
      autoHeight={true}
      localeText={{ noRowsLabel: "No records found." }}
      getRowId={(row: any) => {
        return row[`${rowId}`];
      }}
      disableColumnMenu
      density="standard"
      disableRowSelectionOnClick
      paginationMode="server"
      hideFooter={hidePagination}
    />
  );
};

export default TableDataGrid;
